/**
 * Mock Coach endpoint. Calls into the pure engine + wraps latency so
 * the UI can render a typing indicator. In the real backend this is
 * a streaming Claude call; the UI contract stays the same.
 */

import { advance, type CoachReplyPatch, type CoachState } from '@/features/coach/engine';

const MOCK_LATENCY_MS = 520;
const sleep = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));

export async function askCoach(
  state: CoachState,
  user_text: string,
): Promise<CoachReplyPatch> {
  // A touch of variance on the latency so a stream of messages does
  // not tick like a metronome.
  const jitter = 120 + Math.floor(Math.random() * 220);
  await sleep(MOCK_LATENCY_MS - 120 + jitter);
  return advance(state, user_text);
}
